import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCULz4p3uJR1tHBStc9efJPEX6JTqC69kM",
  authDomain: "posapp-6620a.firebaseapp.com",
  projectId: "posapp-6620a",
  storageBucket: "posapp-6620a.appspot.com",
  messagingSenderId: "345706600763",
  appId: "1:345706600763:web:00dd9e3ba7a13dda377f1e",
  measurementId: "G-ME5N8PLNH1"
};



const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)